export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Black-984e1b77b3b530b7d0c77563b424cc8c.woff2";